import { FindNumerosInutilizaveisParams, FiscalServiceAdapter, SerieENumeroNfParam } from '@/usecases'
import { AxiosRequestConfig } from 'axios'
import { findNumeros, inutiliza } from '@/api/fiscal'

export class FiscalService implements FiscalServiceAdapter {
	findNumerosInutilizaveis = async (params?: FindNumerosInutilizaveisParams, config?: AxiosRequestConfig) => findNumeros(params, config)
	inutiliza = async (seriesFiscais: SerieENumeroNfParam[]) => inutiliza(seriesFiscais)
}
